import { Link } from "react-router-dom";

import { usePageSeo } from "@/hooks/usePageSeo";
import { Button } from "@/components/ui/button";

export const NotFoundPage = () => {
  usePageSeo({
    description: "The requested Content Watch HQ page could not be found.",
    robots: "noindex,nofollow",
    title: "Page Not Found | Content Watch HQ",
  });

  return (
    <main className="page-shell mx-auto max-w-4xl px-4 py-16 sm:px-6 lg:px-8" data-testid="not-found-page">
      <section className="border border-[rgba(10,15,26,0.12)] bg-white p-8 sm:p-10" data-testid="not-found-panel">
        <p className="eyebrow text-red-600" data-testid="not-found-overline">Page unavailable</p>
        <h1 className="mt-3 font-['Outfit'] text-4xl font-black tracking-tight text-slate-950 sm:text-5xl" data-testid="not-found-title">We couldn’t find that page.</h1>
        <p className="mt-4 text-base leading-8 text-slate-700" data-testid="not-found-copy">Head back to the Houston feed and continue with the latest Content Watch coverage.</p>
        <Button asChild className="mt-8 rounded-none bg-[#D21404] px-5 py-6 text-xs font-bold uppercase tracking-[0.2em] text-white hover:bg-[#B31203]" data-testid="not-found-home-button">
          <Link to="/">Return home</Link>
        </Button>
      </section>
    </main>
  );
};